import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import { jsx as _jsx } from "react/jsx-runtime";
const CloneWorkflowRequestFailureAlert = () => /*#__PURE__*/_jsx(UIAlert, {
  className: "m-bottom-5",
  titleText: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "automation-ui-management.CloneWorkflowRequestFailureAlert.title"
  }),
  type: "danger",
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "automation-ui-management.CloneWorkflowRequestFailureAlert.body"
  })
});
export default CloneWorkflowRequestFailureAlert;